import React from 'react'
import Container from '../Container/Index'
import Title from '../Title/Index'
import ImageTag from '../ImageTag/Index'

const Moto = ({Data, certificate}) => {
  return (
   <>
    <Container _parentClass={'ourMoto'} containerClass={'float-end '}>
      <div className='col-lg-9 col-12 m-auto'>
      {(Data.title || Data.heading) && (
  <Title firstHeading={Data.title} secondHeading={Data.heading} />
)}
     <div className='row align-items-center'>
     <div className='col-lg-6 col-12 mb-3 mb-lg-0' data-aos="fade-right"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">
            <ImageTag ImagePath={Data.imagePath} ImageAlt='Our Quality'/>
          </div>
          <div className="col-lg-6 col-12" data-aos="fade-left"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">
            <p dangerouslySetInnerHTML={{ __html: Data.content1}}/>
            <p dangerouslySetInnerHTML={{ __html: Data.content2}}/>
               <ul className='motoListitems'>
            {Data.points.map((items, index) => (
          <li key={index} dangerouslySetInnerHTML={{__html: items}}></li>
        ))}
      </ul>          
         
        </div>   
     </div>
     </div>        
    </Container>
   </>
  )
}

export default Moto